
//$(document).ajaxError(function (event, jqxhr, settings, exception) {
//    if (jqxhr.status == 403) {
//        window.location.href = "/UI";
//    } else {
//        if (!userAborted(jqxhr)) {
//            alert('' + jqxhr.statusText);
//        }
//    }
//});

$.ajaxSetup({
    error: function (xhr, status, err) {
        var code = xhr.status;

        //check for 403 (forbidden on session expired)
        if (code == 403) {
            try {
                //normally we get an url from server where to redirect.
                var data = JSON.parse(xhr.responseText);
                if ((data) && (data.SessionExpiredReturnUrl)) {
                    window.location = data.SessionExpiredReturnUrl;
                }
            } catch (e) {
                alert(e.message);
            }
        } else {
            if (!userAborted(xhr)) {
                //alert('' + xhr.statusText);
            }
        }
    }
});

//register some global handlers
$().ready(function () {
    //register the script for checking logout (e.g. deleting basket items on logout)
    $(".warnOnLogout").click(function (event) {
        event.preventDefault();
        var logoutVm = new LogOutViewModel();
        logoutVm.LogOutUrl = $(this).attr('href');
        
        //get the logout infos
        $.when(logoutVm.GetLogoutInfosAjaxUrl())
        .then(function (data) {

            //if we have items in basket show the dialog, else logout the user
            if (data.ShowDialog) {
                logoutVm.ShowDialog(data);
            }
            else {
                window.location = logoutVm.LogOutUrl;
            } 
        });
    });
})


var LogOutViewModel = function () {
    var self = this;

    self.GetLogoutInfosAjaxUrl = function () {
        var data = {};

        return $.ajax({
            type: 'POST',
            url: getLogoutInfosAjaxUrl,
            data: null, //ko.mapping.toJSON(data),
            contentType: "application/json",
            dataType: 'json'
        });
    };

    self.DeleteBasket = function (url) {
        var data = {};

        return $.ajax({
            type: 'POST',
            url: url,
            data: null, //ko.mapping.toJSON(data),
            contentType: "application/json",
            dataType: 'json'
        });
    };

    self.ShowDialog = function (data) {
        var $dialog = $('<div id="logOutDialog"></div>')
            .html("<div class='logOutDialogText'>" + ((data.Message + '')) + "</div>")
            .dialog({
                open: function (event, ui) { $(".ui-dialog-titlebar-close", ui.dialog).hide(); },
                autoOpen: false,
                modal: true,
                width: 400,
                height: "auto",
                title: '',
                buttons: [
                    {
                        text: data.Ok,
                        click: function () {
                            $(this).dialog("close");
                            window.location = self.LogOutUrl;
                        }
                    },
                    {
                        text: data.Cancel,
                        click: function () {
                            $.when(self.DeleteBasket(data.DeleteUrl))
                                .then(function () {
                                    //$(this).dialog("close");
                                    window.location = self.LogOutUrl;
                                });
                        }
                    }
                ]
            });       
        $dialog.dialog('open');
    };
}
